import React from 'react'
import PropTypes from 'prop-types'
import ChapterDropdown from './ChapterDropdown'
import StudentFilter from './StudentFilter'
import StudentTable from './StudentTable'

class TableSection extends React.Component {
  handleChapterFilter = change => {
    this.props.handleStateChange({ chapterFilter: change }, true)
  }

  handleStudentFilter = change => {
    this.props.handleStateChange({ studentFilter: change }, true)
  }
  // The pager counts a rejection as a failed page load.
  handlePageChange = change =>
    this.props.handleStateChange({ activePage: change }, true).then(ok => {
      if (!ok) throw new Error('The analytics page did not load.')
    })
  handleTableFilterChange = change => {
    if (this.props.tableFilter === change) {
      this.props.handleStateChange(
        { tableFilter: change, filterAscending: !this.props.filterAscending },
        true
      )
    } else {
      this.props.handleStateChange(
        { tableFilter: change, filterAscending: true },
        true
      )
    }
  }

  generateTableContainer = () => {
    return (
      <div>
        <StudentFilter
          numFilteredStudents={this.props.numFilteredStudents}
          numStudents={this.props.numStudents}
          handleChange={this.handleStudentFilter}
          value={this.props.studentFilter}
        />
        <ChapterDropdown
          value={this.props.chapterFilter}
          chapterDropdown={this.props.chapterDropdown}
          handleChange={this.handleChapterFilter}
        />
        <br />
        <StudentTable
          analytics={this.props.analytics}
          coursenum={this.props.coursenum}
          activePage={this.props.activePage}
          totalPages={this.props.totalPages}
          handlePageChange={this.handlePageChange}
          handleTableFilterChange={this.handleTableFilterChange}
          showSimulations={this.props.showSimulations}
          failureMessage={this.props.failureMessage}
        />
      </div>
    )
  }

  generateLoadingPage = () => {
    return (
      <div>
        <div className="intro_box">
          <div className="intro_box_inner text-center">
            <div className="vertical_spacer3" />
            <p className="lead">Compiling Analytics...</p>
            <div className="vertical_spacer3" />
            <div className="icon icon_spinner10 icon_spin2 text50px" />
            <div className="vertical_spacer3" />
          </div>
        </div>

        <div className="vertical_spacer6" />
        <div className="vertical_spacer6" />
        <div className="vertical_spacer6" />
        <div className="vertical_spacer6" />
        <div className="vertical_spacer6" />
      </div>
    )
  }

  render() {
    let content = this.props.loading
      ? this.generateLoadingPage()
      : this.generateTableContainer()
    return <div>{content}</div>
  }
}

TableSection.propTypes = {
  numFilteredStudents: PropTypes.number,
  numStudents: PropTypes.number,
  chapterDropdown: PropTypes.array,
  loading: PropTypes.bool,
  coursenum: PropTypes.string.isRequired,
  handleStateChange: PropTypes.func,
  analytics: PropTypes.array,
  studentFilter: PropTypes.string,
  chapterFilter: PropTypes.string,
  tableFilter: PropTypes.string,
  totalPages: PropTypes.number,
  activePage: PropTypes.number,
  filterAscending: PropTypes.bool,
  showSimulations: PropTypes.bool,
  failureMessage: PropTypes.object,
}

export default TableSection
